import { useEffect, useMemo, useState } from 'react';
import { buildJitteredDemoMap, DEMO_INTERVAL_MS } from '../utils/dtDemoFallback';

/**
 * Re-renders consumers every DEMO_INTERVAL_MS so jittered demo values update.
 * @param {string} widgetType key in DT_DEMO_BASES
 * @returns {Record<string, number|string>}
 */
export function useDTDemoMap(widgetType) {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), DEMO_INTERVAL_MS);
    return () => clearInterval(id);
  }, []);
  return useMemo(() => buildJitteredDemoMap(widgetType, tick), [widgetType, tick]);
}
